import { useCallback, useEffect, useEffectEvent } from 'react';

import { useIntersection } from '@jsmdg/yoshi';

export function useImpressionTracking(
    trackingCallback: () => void,
): (element: HTMLAnchorElement | HTMLDivElement | null) => void {
    const [isInViewport, setIntersectionTrackedElement] = useIntersection({
        threshold: 0.5,
        triggerOnce: true,
    });
    const onImpression = useEffectEvent(trackingCallback);

    useEffect(() => {
        if (isInViewport) {
            onImpression();
        }
    }, [isInViewport]);

    return useCallback(
        (element: HTMLAnchorElement | HTMLDivElement | null): void => {
            if (element) {
                setIntersectionTrackedElement(element);
            }
        },
        [setIntersectionTrackedElement],
    );
}
